import React from 'react'

export const DisclaimerWarning = () => {
  return (
    <div className="card">
      <p className="text-info is-vertical-align">
        Disclaimer: this application is for educational purposes only.
      </p>
    </div>
  )
}
